import React, { useContext } from 'react'
import { LogoContext } from '../../contexts/LogoContext';

const UploadLogo = () => {
    const { logos, dispatch } = useContext(LogoContext);

    const fileSelectedHandler = event => {
        event.preventDefault();

        let reader = new FileReader();
        let file = event.target.files[0];
        if (file === undefined) return;
        
        var fileInfo = document.getElementById('choose-file');
        var fileLabel = document.getElementById('file-label');
        if (fileInfo.value === "")
        {
            fileLabel.innerHTML = "Choose file";
        }
        else
        {
            var theSplit = fileInfo.value.split('\\');
            fileLabel.innerHTML = theSplit[theSplit.length-1];
            dispatch({ type: 'UPDATE_LOCAL_LABEL', localLabel: fileLabel.innerHTML })
        }
        
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            dispatch({ type: 'UPDATE_LOCAL_URL', url: reader.result}); 
            dispatch({ type: 'UPDATE_LOCAL_FILE', localFile: file}); 
        }
    }

    const logoSizeHandler = event => {
        event.preventDefault();
        dispatch({ type: 'UPDATE_LOCAL_WIDTH', width: event.target.value})
    }
    return ( 
        <div className="upload-logo">
            <input 
                id="choose-file"
                type="file" 
                onChange={fileSelectedHandler}
                accept="image/*,.pdf"
                />
                <br/>
            <small>
            <label id="file-label">{logos.localLabel}</label>
            </small>
            <br/>
            <input 
                id="logo-width"
                type="text"
                onChange={logoSizeHandler}
                value={logos.localWidth}
                style={{width:'30px'}}
            />
            <small>
                <label id="logo-width">% Logo Size</label>
            </small>
        </div>
     );
}
 
export default UploadLogo;
